var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pui-attribute-table-indicators pui-attribute-table-indicators__root"},[(_vm.dnd.target != -1)?_c('div',{staticClass:"pui-attribute-table-indicators__target-indicator",style:({ top: `${_vm.dnd.insertIndicator.y - 1}px` })}):_vm._e(),(_vm.dnd.target != -1)?_c('div',{staticClass:"pui-attribute-table-indicators__dragging-indicator",style:({
      top: `${_vm.dnd.ghostRowIndicator.y}px`,
      height: `${_vm.dnd.ghostRowIndicator.height}px`,
    })}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }